import { render, staticRenderFns } from "./FastArticle.vue?vue&type=template&id=4c2e4bf6&scoped=true&"
import script from "./FastArticle.vue?vue&type=script&lang=js&"
export * from "./FastArticle.vue?vue&type=script&lang=js&"
import style0 from "./FastArticle.vue?vue&type=style&index=0&id=4c2e4bf6&prod&scoped=true&lang=css&"
import style1 from "./FastArticle.vue?vue&type=style&index=1&id=4c2e4bf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e4bf6",
  null
  
)

export default component.exports